import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons";
import Rate from "../../components/Rating";
//import { Link} from 'react-router-dom';

const TaskMskill = ({ taskSubmitted }) => {
  const taskExpertReviewStatus = taskSubmitted?.user_task
    ? taskSubmitted?.user_task?.review_status_resubmission === "none"
      ? taskSubmitted?.user_task?.review_status !== "none"
        ? taskSubmitted?.user_task?.review_status === "pending" ||
          taskSubmitted?.user_task?.review_status === "in_review"
          ? "In Review"
          : "Reviewed"
        : "Review pending"
      : taskSubmitted?.user_task?.review_status_resubmission === "pending"
      ? "Re-Submit"
      : taskSubmitted?.user_task?.review_status_resubmission === "in_review"
      ? "In Review"
      : "Reviewed"
    : "Incomplete";
  const gradeImg = {
    1: "https://assets.learntube.ai/files/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801",
    2: "https://assets.learntube.ai/files/Content_player/Group_5545.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485587",
    3: "https://assets.learntube.ai/files/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311",
    4: "https://assets.learntube.ai/files/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311",
    5: "https://assets.learntube.ai/files/Content_player/Group_5507.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484567",
  };
  const getGrade = (score) => {
    if (score <= 10) {
      return { score, grade: 1, img: gradeImg[1], text: "Poor" };
    } else if (score <= 20) {
      return { score, grade: 2, img: gradeImg[2], text: "Average" };
    } else if (score <= 30) {
      return { score, grade: 3, img: gradeImg[3], text: "Good" };
    } else if (score <= 40) {
      return { score, grade: 4, img: gradeImg[4], text: "Very Good" };
    } else if (score <= 50) {
      return { score, grade: 5, img: gradeImg[5], text: "Excellent" };
    }
  };

  const gradeObj =
    taskExpertReviewStatus === "Reviewed"
      ? getGrade(
          taskSubmitted?.user_task?.review_status === "pending" ||
            taskSubmitted?.user_task?.review_status === "in_review"
            ? taskSubmitted?.user_task?.review_rating_resubmission
            : taskSubmitted?.user_task?.review_rating
        )
      : {
          score: 0,
          grade: 0,
          img: "https://assets.learntube.ai/files/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801",
          text: "",
        };
  return (
    <div className=" flex w-full cursor-pointer flex-col items-center justify-center px-2 md:px-3">
      <div
        className={`flex w-full items-center justify-between rounded-sm border-[0.5px]  py-2 px-2 md:px-4 ${
          taskExpertReviewStatus === "Reviewed"
            ? "border-[#10A080]"
            : taskSubmitted?.user_microskill?.completed &&
              (taskExpertReviewStatus === "Review pending" ||
                taskExpertReviewStatus === "Incomplete" ||
                taskExpertReviewStatus === "Re-Submit")
            ? "border-red-400"
            : "border-[#B7B7B7]"
        } `}
      >
        <div className=" flex w-2/3 items-center justify-start">
          <FontAwesomeIcon
            icon={faClipboardCheck}
            className={`${
              taskExpertReviewStatus === "Reviewed"
                ? "text-[#10A080]"
                : taskSubmitted?.user_microskill?.completed &&
                  (taskExpertReviewStatus === "Review pending" ||
                    taskExpertReviewStatus === "Incomplete" ||
                    taskExpertReviewStatus === "Re-Submit")
                ? "text-red-400"
                : "text-[#636868]"
            } mr-3 `}
            size="2xl"
          ></FontAwesomeIcon>
          <div className="mr-2 flex flex-col ">
            <div
              className={`text-xs font-medium ${
                taskExpertReviewStatus === "Reviewed"
                  ? "text-[#10A080]"
                  : taskSubmitted?.user_microskill?.completed &&
                    (taskExpertReviewStatus === "Review pending" ||
                      taskExpertReviewStatus === "Incomplete" ||
                      taskExpertReviewStatus === "Re-Submit")
                  ? "text-red-400"
                  : "text-[#9B9B9B]"
              } `}
            >
              Project
            </div>
            <div
              className={`text-sm font-semibold ${
                taskExpertReviewStatus === "Reviewed"
                  ? "text-[#10A080]"
                  : taskSubmitted?.user_microskill?.completed &&
                    (taskExpertReviewStatus === "Review pending" ||
                      taskExpertReviewStatus === "Incomplete" ||
                      taskExpertReviewStatus === "Re-Submit")
                  ? "text-red-400"
                  : "text-[#636868]"
              } `}
            >
              {taskSubmitted?.task_title}
            </div>
          </div>
        </div>
        <div className="flex w-1/2 items-center justify-end text-center ">
          {taskExpertReviewStatus === "Incomplete" ? (
            <div className="mr-1 rounded-sm bg-[#10A786] px-4 py-1 text-sm text-white md:mr-4">
              Start
            </div>
          ) : (
            taskExpertReviewStatus === "Review pending" && (
              <div className="mr-1 rounded-sm bg-[#FDBF48] px-2 py-1 text-sm font-semibold text-black md:mr-4">
                Request Review
              </div>
            )
          )}
          <Rate
            rating={gradeObj?.grade}
            color={{
              filled: "#FFD700",
              unfilled: "#808080",
            }}
            count={5}
            size={"sm"}
            isReadOnly={true}
          />
        </div>
      </div>
      <div
        className={`mt-[0.5px] self-end text-xs font-medium ${
          taskExpertReviewStatus === "Review pending" ||
          taskExpertReviewStatus === "Incomplete" ||
          taskExpertReviewStatus === "Re-Submit"
            ? "text-red-500"
            : "text-[#10A988]"
        }`}
      >
        {taskExpertReviewStatus}
      </div>
    </div>
  );
};

export default TaskMskill;
